import type {RouteObject} from '@github-ui/react-router'

import {AgentsRouteRedirect} from './AgentsRouteRedirect'
import {CopilotAgentsPage} from './CopilotAgentsPage'
import {CopilotAgentsTaskPage} from './CopilotAgentsTaskPage'
import {CopilotAgentsConversationPage} from './CopilotAgentsConversationPage'
import {PersistentAgentsChatHost, PersistentAgentsTaskRouteErrorBoundary} from './PersistentAgentsChatHost'
import {canonicalCopilotAgentsRoute, copilotAgentsRoute} from './copilot-agents-route'
import {copilotAgentsTaskRoute} from './copilot-agents-task-route'
import {
  canonicalCopilotAgentsConversationRoute,
  copilotAgentsConversationRoute,
} from './copilot-agents-conversation-route'
import {CopilotAgentsNewSpacePage} from './spaces/AgentsNewSpacePage'
import {CopilotAgentsSpaceDetailPage} from './spaces/AgentsSpaceDetailPage'
import {CopilotAgentsSpacesListPage} from './spaces/AgentsSpacesListPage'
import {canonicalCopilotAgentsNewSpaceRoute, copilotAgentsNewSpaceRoute} from './spaces/copilot-agents-new-space-route'
import {canonicalCopilotAgentsSpaceRoute, copilotAgentsSpaceRoute} from './spaces/copilot-agents-space-route'
import {canonicalCopilotAgentsSpacesRoute, copilotAgentsSpacesRoute} from './spaces/copilot-agents-spaces-route'
import {CopilotAgentsCustomizePage} from './customize/AgentsCustomizePage'
import {copilotAgentsCustomizeRoute} from './customize/copilot-agents-customize-route'
import {getCopilotAgentsRouteSet} from './copilot-agents-route-set'

export const CopilotAgentsLayout = PersistentAgentsChatHost

export const copilotAgentsPageRoute = copilotAgentsRoute.toRoute({Component: CopilotAgentsPage})
export const canonicalCopilotAgentsPageRoute = canonicalCopilotAgentsRoute.toRoute({Component: CopilotAgentsPage})
export const copilotAgentsTaskPageRoute = copilotAgentsTaskRoute.toRoute({
  Component: CopilotAgentsTaskPage,
  errorBoundary: {override: PersistentAgentsTaskRouteErrorBoundary},
})
export const copilotAgentsConversationPageRoute = copilotAgentsConversationRoute.toRoute({
  Component: CopilotAgentsConversationPage,
})
export const canonicalCopilotAgentsConversationPageRoute = canonicalCopilotAgentsConversationRoute.toRoute({
  Component: CopilotAgentsConversationPage,
})
export const canonicalCopilotAgentsSpacesPageRoute = canonicalCopilotAgentsSpacesRoute.toRoute({
  Component: CopilotAgentsSpacesListPage,
})
export const canonicalCopilotAgentsNewSpacePageRoute = canonicalCopilotAgentsNewSpaceRoute.toRoute({
  Component: CopilotAgentsNewSpacePage,
})
export const canonicalCopilotAgentsSpacePageRoute = canonicalCopilotAgentsSpaceRoute.toRoute({
  Component: CopilotAgentsSpaceDetailPage,
})
export const copilotAgentsSpacesPageRoute = copilotAgentsSpacesRoute.toRoute({Component: CopilotAgentsSpacesListPage})
export const copilotAgentsNewSpacePageRoute = copilotAgentsNewSpaceRoute.toRoute({Component: CopilotAgentsNewSpacePage})
export const copilotAgentsSpacePageRoute = copilotAgentsSpaceRoute.toRoute({Component: CopilotAgentsSpaceDetailPage})
export const canonicalCopilotAgentsCustomizePageRoute = copilotAgentsCustomizeRoute.toRoute({
  Component: CopilotAgentsCustomizePage,
})

export function getCopilotAgentsAppRoutes(taskRouteEnabled: boolean, oneCopilotChatEnabled = false): RouteObject[] {
  const routeSet = getCopilotAgentsRouteSet(oneCopilotChatEnabled)
  const agentsPageRoute =
    routeSet.agents === canonicalCopilotAgentsRoute ? canonicalCopilotAgentsPageRoute : copilotAgentsPageRoute

  return [
    ...(oneCopilotChatEnabled ? [{path: '/copilot/agents/*', Component: AgentsRouteRedirect}] : []),
    {
      Component: CopilotAgentsLayout,
      children: [agentsPageRoute, ...(taskRouteEnabled ? [copilotAgentsTaskPageRoute] : [])],
    },
    ...(oneCopilotChatEnabled
      ? [
          canonicalCopilotAgentsConversationPageRoute,
          canonicalCopilotAgentsSpacesPageRoute,
          canonicalCopilotAgentsNewSpacePageRoute,
          canonicalCopilotAgentsSpacePageRoute,
          canonicalCopilotAgentsCustomizePageRoute,
        ]
      : []),
  ]
}
